import { render } from "./BotDataCollection.vue?vue&type=template&id=0c21a6a2"
import script from "./BotDataCollection.vue?vue&type=script&lang=js"
export * from "./BotDataCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__